import { createReducer, on } from '@ngrx/store';
import * as BusCheckActions from '../actions/bus-check-list.actions';
import { BusCheckState } from '../states/bus-check-list.state';

export const initialState: BusCheckState = { loading: false, busChecks: [] };

export const busCheckReducer = createReducer(
    initialState,
    on(BusCheckActions.loadBusChecks, (state) => ({ ...state, loading: true })),
    on(BusCheckActions.loadBusChecksSuccess, (state, { busChecks }) => ({ ...state, loading: false, busChecks })),
    on(BusCheckActions.addBusCheck, (state, { busCheck }) => ({...state, busChecks: [...state.busChecks, busCheck] })),
    on(BusCheckActions.updateBusCheck, (state, { busCheck }) => ({
        ...state,
        busChecks: state.busChecks.map(b => b.id === busCheck.id ? busCheck : b)
    })),
    on(BusCheckActions.deleteBusCheck, (state, { id }) => ({
        ...state,
        busChecks: state.busChecks.filter(b => b.id !== id)
    }))
);